import * as React from 'react';
import { StyleSheet, css, CSSProperties } from 'aphrodite/no-important';
import { CardOverlay } from '../../CardOverlay';
import { Image } from '../../image/Image';
import { CardCaptionContainer, CARD_CAPTION_CONTAINER_TYPES } from '../../CardCaptionContainer';
import { useTheme } from '../../../../theming/useTheme';
import { PlayIcon } from '../../PlayIcon';
import { WrapperForSafariBorderRadiusBug } from '../WrapperForSafariBorderRadiusBug';
import { Thumbnail } from '../../image/image.types';
import { EventContext } from '../../../../analytics/analytics';
import { Link } from '../../link/Link';

const numberOfLines = 2;
const componentConfigThemeKey = 'onTopCard';

interface OnTopCardComponentDataProps {
  title: string
  image: Thumbnail
  coverType?: string
  articleUrl: string
  lazyLoad?: boolean
}

interface OnTopCardComponentThemeProps {
  cardTextColor: string
  cardTextTagName: string
  surfaceStyle: CSSProperties
}


type OnTopCardComponentProps = OnTopCardComponentDataProps & OnTopCardComponentThemeProps;
const createCardStyles = (cardTextColor: string) => StyleSheet.create({
  card: {
    width: '100%',
    height: '100%',
    position: 'relative',
    textDecoration: 'none',
    color: cardTextColor,
    display: 'block',
    '-webkit-mask-image': '-webkit-radial-gradient(white, black)',
  },
});


export const OnTopCardComponent: React.FunctionComponent<OnTopCardComponentProps> = props => {
  const { title, image, articleUrl, coverType, cardTextColor, surfaceStyle, lazyLoad = false } = props;
  const cardStyles = createCardStyles(cardTextColor);
  return (
    <WrapperForSafariBorderRadiusBug surfaceStyle={surfaceStyle}>
      <Link
        className={css(
          cardStyles.card,
          StyleSheet.create({ surfaceStyle }).surfaceStyle,
        )}
        href={articleUrl}
      >
        <Image {...image} lazyLoad={lazyLoad} />
        <CardOverlay />
        <CardCaptionContainer numberOfLines={numberOfLines} type={CARD_CAPTION_CONTAINER_TYPES.ON_TOP}>
          <h3>{title}</h3>
        </CardCaptionContainer>
        {coverType === 'video' ? <PlayIcon /> : null}
      </Link>
    </WrapperForSafariBorderRadiusBug>
  );
};


const mapThemeProps = (theme: OnTopCardComponentThemeProps) => {
  return {
    cardTextColor: theme.cardTextColor,
    cardTextTagName: theme.cardTextTagName,
    surfaceStyle: theme.surfaceStyle,
  };
};

export const OnTopCard = (props: OnTopCardComponentDataProps) => {
  const themeContext = useTheme(componentConfigThemeKey, mapThemeProps);
  return <OnTopCardComponent {...themeContext} {...props} />;
};
